import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('guidance.formMastSettings')), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_data_table, {
        headers: _ctx.headers,
        items: _ctx.mastResponse ? _ctx.mastResponse.data : [],
        loading: _ctx.loading,
        "hide-default-footer": "",
        "items-per-page": -1
      }, {
        [`item.type`]: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(_ctx.getPlanText(item.type)), 1)
        ]),
        [`item.createdAt`]: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(_ctx.formatDate(item.createdAt)), 1)
        ]),
        [`item.duplicate`]: _withCtx(({ item }) => [
          _createVNode(_component_v_btn, {
            onClick: ($event: any) => (_ctx.duplicateForm(item.id)),
            disabled: _ctx.loading,
            color: "primary",
            variant: "outlined",
            small: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('guidance.duplicateToFormSettings')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ]),
        _: 2
      }, 1032, ["headers", "items", "loading"])
    ])
  ]))
}